<template>
    <div>
        <ProfileBlock :title="$t('components.profile_view.block_name')">
            <dl class="sm:divide-y">
                <div
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Name
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        <span v-if="!profile.first_name && !profile.last_name">
                            -
                        </span>
                        <span v-if="profile.first_name || profile.last_name">
                            {{ profile.first_name }} {{ profile.last_name }}
                        </span>
                    </dd>
                </div>
                <div
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Phone
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        {{ profile.phone || "-" }}
                    </dd>
                </div>
                <div
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Email
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        {{ profile.email || "-" }}
                    </dd>
                </div>
            </dl>

            <template v-slot:block-link>
                <router-link
                    tag="div"
                    :to="{ name: 'ManageProfile' }"
                    v-dr-permission="'drg.app.profile.edit'"
                >
                    {{ $t("components.profile_view.manage_button") }}
                </router-link>
            </template>
        </ProfileBlock>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "Profile",
    components: { ProfileBlock },
    methods: mapActions({ fetch: "profile/fetch" }),
    computed: mapGetters({ profile: "profile/profile" }),
    mounted() {
        this.fetch();
    }
};
</script>
